import { application } from "../../../app"

import AlertComponentController from "./alert_component_controller"
application.register("design-system--alert-component", AlertComponentController)

import ClipboardComponentController from "./clipboard_component_controller"
application.register("design-system--clipboard-component", ClipboardComponentController)

import CommandPaletteComponentController from "./command_palette_component_controller"
application.register("design-system--command-palette-component", CommandPaletteComponentController)

import FormColorPickerInputComponentController from "./form/color_picker_input_component_controller"
application.register("design-system--form--color-picker-input-component", FormColorPickerInputComponentController)

import FormDatetimePickerComponentController from "./form/datetime_picker_component_controller"
application.register("design-system--form--datetime-picker-component", FormDatetimePickerComponentController)

import FormFileInputGroupComponentController from "./form/file_input_group_component_controller"
application.register("design-system--form--file-input-group-component", FormFileInputGroupComponentController)

import FormMultipleFileInputGroupComponentController from "./form/multiple_file_input_group_component_controller"
application.register("design-system--form--multiple-file-input-group-component", FormMultipleFileInputGroupComponentController)

import FormRichTextComponentController from "./form/rich_text_component_controller"
application.register("design-system--form--rich-text-component", FormRichTextComponentController)

import FormSelectComponentController from "./form/select_component_controller"
application.register("design-system--form--select-component", FormSelectComponentController)

import FormToggleableComponentController from "./form/toggleable_component_controller"
application.register("design-system--form--toggleable-component", FormToggleableComponentController)

import DropdownButtonComponentController from "./dropdown_button_component_controller"
application.register("design-system--dropdown-button-component", DropdownButtonComponentController)

import LoaderComponentController from "./loader_component_controller"
application.register("design-system--loader-component", LoaderComponentController)

import MenuComponentController from "./menu_component_controller"
application.register("design-system--menu-component", MenuComponentController)

import ModalComponentController from "./modal_component_controller"
application.register("design-system--modal-component", ModalComponentController)

import ModalConfirmComponentController from "./modal_confirm_component_controller"
application.register("design-system--modal-confirm-component", ModalConfirmComponentController)

import ModalFilterComponentController from "./modal_filter_component_controller"
application.register("design-system--modal-filter-component", ModalFilterComponentController)

import PopoverComponentController from "./popover_component_controller"
application.register("design-system--popover-component", PopoverComponentController)

import SlideOverComponentController from "./slide_over_component_controller"
application.register("design-system--slide-over-component", SlideOverComponentController)

import TooltipComponentController from "./tooltip_component_controller"
application.register("design-system--tooltip-component", TooltipComponentController)

import ToastrComponentController from "./toastr_component_controller"
application.register("design-system--toastr-component", ToastrComponentController)
